'use client';

import { useState } from 'react';
import { SnackBar } from '@pixum/snackbar';
import { Icon } from '@pixum/icon';
import { CART_HINT_SNACKBAR_VARIANT } from '../../constants/cartHintSnackbar';
import type { CartHintSnackbarVariant } from '../../types/cartHintSnackbar';
import styles from './CartHintSnackbar.module.css';

interface CartHintSnackbarProps {
  message: string;
  linkText: string;
  variant?: CartHintSnackbarVariant;
}

export function CartHintSnackbar({
  message,
  linkText,
  variant = CART_HINT_SNACKBAR_VARIANT.FLOATING
}: CartHintSnackbarProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const isBanner = variant === CART_HINT_SNACKBAR_VARIANT.BANNER;

  return (
    <div className={isBanner ? `${styles['wrapper']} ${styles['banner']}` : styles['wrapper']} role="status">
      <SnackBar
        theme={{ base: isBanner ? 'brand' : 'ink', accent: 'brand', brightness: 'dark' }}
        icon={<Icon name="warningsignal" ariaHidden />}
        message={message}
        linkText={linkText}
        onClick={() => setDismissed(true)}
      />
    </div>
  );
}
